import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Text, Input } from '../ui';
import { Replace, ReplaceAll } from 'lucide-react';

const FeedbackPostForm = ({ post, onFeedbackSubmit, onCancel }) => {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    control,
  } = useForm({
    defaultValues: {
      userInput: '',
    },
  });

  const userInput = watch('userInput');

  const onSubmit = async (data) => {
    if (!data.userInput.trim()) return;
    await onFeedbackSubmit(data.userInput);
    reset();
  };

  const isPublished = post?.status === 'published';

  return (
    <div className='w-full h-full flex flex-col overflow-hidden '>
      {/* Header */}
      <div className='flex items-center gap-2 mb-4'>
        <div className='w-6 h-6 flex items-center justify-center'>
          <ReplaceAll className='w-5 h-5' style={{ color: 'var(--brand)' }} />
        </div>
        <Text variant='caption' className='font-bold tracking-tight uppercase mb-0' style={{ color: 'var(--text-primary)' }}>
          Feedback
        </Text>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col px-2 flex-1 overflow-y-auto'>
        <div className='space-y-6'>
          {/* Description */}
          <Text variant='caption' className='' style={{ color: 'var(--text-body)' }}>
            Please provide your feedback for this post.
          </Text>

          {/* Textarea */}
          <div className='flex flex-col flex-1'>
            <Controller
              name='userInput'
              control={control}
              rules={{
                required: 'Please provide feedback',
                minLength: {
                  value: 3,
                  message: 'Feedback must be at least 3 characters',
                },
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  type='textarea'
                  placeholder="Examples:&#10;• The post doesn't match my brand voice&#10;• The hashtags feel generic&#10;• The app could have X feature&#10;"
                  disabled={isSubmitting || isPublished}
                  rows={8}
                />
              )}
            />
            {errors.userInput && (
              <Text variant='caption' className='text-red-500 mt-2'>
                {errors.userInput.message}
              </Text>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className='flex flex-col items-center gap-3 mt-6 pt-6 px-2'>
          <Button
            type='submit'
            disabled={
              isSubmitting || isPublished || !userInput?.trim() || userInput.trim().length < 3
            }
            variant='primary'
            className='w-full py-3 text-base font-medium'
            loading={isSubmitting}
            icon={Replace}
            iconPosition='left'
          >
            {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
          </Button>
          <Button
            type='button'
            onClick={onCancel}
            disabled={isSubmitting || isPublished}
            variant='text'
          >
            <Text variant='caption'>Cancel and return</Text>
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FeedbackPostForm;
